import campagn from "../../api/campaign";
import { perPageCount } from "@/common/constants";
import { dummyRows, StatusIcon, convertCount } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    itemLoaded: false,
    spamCheckStaus: 0,
    spamCheckStausB: 0,
    spamCheckedId: "",
    spamCheckedIdB: "",
    publishedStatus: "",
    contactList: [],
    segmentList: [],
    filter: {
      page: 1,
      per_page_count: perPageCount,
      camp_name: "",
      date_from: "",
      date_to: "",
      senderId: "",
      status: "",
      sort_field: "modifiedDate",
      sort_order: "desc",
      add_sort: 0,
    },
    editItem: {},
    editItemB: {},
    spamDetails: {},
    spamDetailsB: {},
    totalItems: 0,
    total: 0,
    busyLoaderStatus: true,
    showFilter: false,
    createOrEdit: "",
    templateContent: "",
    advancedCampaignOptions: 0,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items.map((item) => {
      return {
        id: item.id,
        cname: {
          title: item.cname,
          text: item.subject,
          type: parseInt(item.type) === 1 ? "" : "A/B",
        },
        isNormal: parseInt(item.type) === 1,
        showCampaign: item.showCampaign,
        isAdvanced: parseInt(item.isAdvanced),
        cam_status: { text: item.status, type: StatusIcon(item.status) },
        scheduleDate: item.date,
        modifiedTime: item.upTime,
        pause_message: item.pauseMessage ? item.pauseMessage : "",
        openRate: {
          first: item.openRate + "%",
          second: convertCount(item.opens),
        },
        isTimeBased: item.isTimeBased,
        isAmp: [3, 4].includes(item.contenttype),
        cam_actions: {
          Delete: item.status !== "Draft" && item.status !== "Duplicate",
          "Test Mail": parseInt(item.type) !== 1,
          Abort:
            item.status !== "Paused" &&
            item.status !== "Processing" &&
            item.status !== "Scheduled",
          Pause:
            item.status !== "Processing" &&
            item.status !== "Queued" &&
            item.status !== "Sending" &&
            item.status !== "Scheduled" &&
            item.status !== "Rescheduled",
          Resume: item.status !== "Paused",
          Edit:
            item.status !== "Paused" &&
            item.status !== "Draft" &&
            item.status !== "Duplicate",
        },
      };
    });
  },

  getContactList: (state) => {
    return state.contactList.map((item) => {
      state.totalSubscribers = state.totalSubscribers + item.count;
      return {
        value: item.id,
        text: item.name,
        count: convertCount(item.count),
      };
    });
  },
  getTotalContacts: (state) => {
    var list = 0;
    var seg = 0;
    state.contactList.map((item) => {
      list = list + item.count;
    });
    state.segmentList.map((item) => {
      seg = seg + item.count;
    });
    return { list: list, segment: seg };
  },

  getCreateOrEdit: (state) => {
    return state.createOrEdit ? state.createOrEdit : "Edit";
  },

  getSegmentList: (state) => {
    return state.segmentList.map((item) => {
      return {
        value: item.id,
        text: item.name,
        count: convertCount(item.count),
      };
    });
  },

  getBrokenLinksCount: (state) => {
    if (!state.editItem.brokenLinks) {
      return 0;
    }
    return state.editItem.brokenLinks.filter((item) => {
      return !item.status;
    }).length;
  },

  getBlackListCount: (state) => {
    if (!state.spamDetails.blacklistDetails) {
      return 0;
    }
    return Object.keys(state.spamDetails.blacklistDetails).length;
  },
};

// actions
const actions = {
  campaignanalyticsExport(_, params) {
    return campagn.campaignanalyticsExport(params);
  },
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.camp_name !== params.camp_name ||
      filter.date_from !== params.date_from ||
      filter.date_to !== params.date_to ||
      filter.senderId !== params.senderId ||
      filter.status !== params.status ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve) {
        campagn.fetchItems(params, (data) => {
          commit("setAdvancedCampaignOptions", data.advancedCampaign);
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },

  clearSingleItem({ commit }) {
    commit("setItemLoaded", false);
    commit("setEditItem", {});
    commit("setEditItemB", {});
  },

  fetchSingleItem({ commit, state, dispatch }, { id, disableSpamcheck }) {
    var check = 0;
    if (!state.itemLoaded || state.editItem.id !== id) {
      commit("setItemLoaded", true);
      commit("setEditItem", { id: id });
      commit("setSpamCheckStaus", 0);
      commit("setSpamCheckStausB", 0);
      campagn.getSingleItem(id, (data, dataB) => {
        if (
          !disableSpamcheck &&
          (data.html || data.plaintext) &&
          data.senderId &&
          (data.spamScore === null ||
            data.spamScore === "" ||
            data.spamScore === "-1" ||
            data.blacklistlinks === 2)
        ) {
          check = 1;
          commit("setSpamCheckStaus", 0);
          commit("setSpamCheckStausB", 0);
          dispatch("fetchSpamScore", {
            campaignId: id,
            campaignType: data.type,
          });
        }
        var rule = data.rule ? JSON.parse(data.rule) : {};
        if (rule.waitingUnit) {
          rule.waitingUnit = parseInt(rule.waitingUnit);
        }
        if (rule.pauseUnit) {
          rule.pauseUnit = parseInt(rule.pauseUnit);
        }
        data.tagId = data.tagId ? data.tagId : "";
        if (rule.waitingUnit && rule.waitingUnit > 1) {
          data.waitingTime = data.waitingTime / 60;
        }
        if (rule.waitingUnit && rule.waitingUnit > 2) {
          data.waitingTime = data.waitingTime / 24;
        }
        if (!data.waitingTime || data.waitingTime === "0") {
          data.waitingTime = "";
        }
        var pauseRules = data.pauseRules ? JSON.parse(data.pauseRules) : {};
        if (pauseRules.pauseUnit && pauseRules.pauseUnit > 1) {
          pauseRules.pauseTime = pauseRules.pauseTime / 60;
        }
        if (pauseRules.pauseUnit && pauseRules.pauseUnit > 2) {
          pauseRules.pauseTime = pauseRules.pauseTime / 24;
        }
        var brokenLinks = data.brokenLinks ? JSON.parse(data.brokenLinks) : [];
        var spamReport = data.spamReport ? JSON.parse(data.spamReport) : [];
        commit("setEditItem", {
          ...data,
          ...rule,
          ...pauseRules,
          brokenLinks,
          spamReport,
          id,
        });
        commit("setSpamDetails", { ...data, brokenLinks, spamReport });
        if (dataB) {
          if (
            !check &&
            !disableSpamcheck &&
            (dataB.html || dataB.plaintext) &&
            dataB.senderId &&
            (data.spamScore === null ||
              dataB.spamScore === "" ||
              dataB.spamScore === "-1" ||
              dataB.blacklistlinks === 2)
          ) {
            dispatch("fetchSpamScore", {
              campaignId: dataB.id,
              campaignType: dataB.type,
            });
          }
          dataB.tagId = dataB.tagId ? dataB.tagId : "";
          rule = dataB.rule ? JSON.parse(dataB.rule) : {};
          pauseRules = dataB.pauseRules ? JSON.parse(dataB.pauseRules) : {};
          brokenLinks = dataB.brokenLinks ? JSON.parse(dataB.brokenLinks) : [];
          spamReport = dataB.spamReport ? JSON.parse(dataB.spamReport) : [];
          commit("setEditItemB", {
            ...dataB,
            ...rule,
            ...pauseRules,
            brokenLinks,
            spamReport,
          });
          commit("setSpamDetailsB", { ...dataB, brokenLinks, spamReport });
        }
      });
    }
  },

  fetchRecipients({ commit }, params) {
    campagn.getRecipients(params, (data) => {
      commit("setRecipients", data);
    });
    campagn.getSegments(params, (data) => {
      commit("setSegments", data);
    });
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  deleteCampaign({ dispatch }, { id }) {
    return campagn.delete(id).then(function () {
      dispatch("refreshItems");
    });
  },

  duplicateCampaign({ dispatch }, { id }) {
    return campagn.duplicate(id).then(function () {
      dispatch("refreshItems");
    });
  },

  testMail(_, params) {
    return campagn.testMail(params);
  },

  abortCampaign({ dispatch }, params) {
    return campagn.abortCampaign(params).then(function () {
      dispatch("refreshItems");
    });
  },
  pauseCampaign({ dispatch }, params) {
    return campagn.pauseCampaign(params).then(function () {
      dispatch("refreshItems");
    });
  },
  resumeCampaign({ dispatch }, params) {
    return campagn.resumeCampaign(params).then(function (res) {
      dispatch("refreshItems");
      return res;
    });
  },

  deleteTemplate({ commit, state }, params) {
    var type = params.type === 3 ? "B" : "";
    return campagn
      .deleteTemplate(params)
      .then(function (response) {
        commit("setEditItem" + type, {
          ...state["editItem" + type],
          ...response.data,
        });
      })
      .catch(() => {
        commit("setEditItem" + type, {
          ...state["editItem" + type],
          ...{
            creativeThumb: "",
            html: "",
            ampContent: "",
            plaintext: "",
            editorType: 0,
          },
        });
      });
  },
  createImage(_, params) {
    return campagn.createImage(params);
  },
  saveData({ commit, state }, params) {
    return campagn.saveCampaign(params).then(function (response) {
      if (response.data.id) {
        var id = params.id ? params.id : response.data.id;
        var brokenLinks = response.data.brokenLinks
          ? JSON.parse(response.data.brokenLinks)
          : [];
        if (params.type === 3) {
          commit("setSpamDetailsB", {
            ...state.spamDetailsB,
            ...params,
            ...response.data,
          });
          commit("setEditItemB", {
            ...state.editItemB,
            ...params,
            ...response.data,
            brokenLinks,
            id,
          });
          commit("setEditItem", {
            ...state.editItem,
            senderId: params.senderId,
            tagId: params.tagId,
            tagName: params.tagName,
            replyId: params.replyId,
            senderEmail: params.senderEmail,
          });
        } else {
          commit("setSpamDetails", {
            ...state.spamDetails,
            ...params,
            ...response.data,
          });
          commit("setEditItem", {
            ...state.editItem,
            ...params,
            ...response.data,
            brokenLinks,
            id,
          });
          commit("setEditItemB", {
            ...state.editItemB,
            senderId: params.senderId,
            tagId: params.tagId,
            tagName: params.tagName,
            replyId: params.replyId,
            senderEmail: params.senderEmail,
          });
        }
        if (params.templateId || params.layoutId) {
          return response.data;
        }
        return id;
      } else {
        throw response;
      }
    });
  },

  autoSave({ commit, state }, params) {
    return campagn.autoSave(params).then(function (response) {
      var id = params.id;
      var brokenLinks = response.data.brokenLinks
        ? JSON.parse(response.data.brokenLinks)
        : [];
      if (params.type === 3) {
        commit("setSpamDetailsB", {
          ...state.spamDetailsB,
          ...params,
          ...response.data,
        });
        commit("setEditItemB", {
          ...state.editItemB,
          ...params,
          ...response.data,
          brokenLinks,
          id,
        });
      } else {
        commit("setSpamDetails", {
          ...state.spamDetails,
          ...params,
          ...response.data,
        });
        commit("setEditItem", {
          ...state.editItem,
          ...params,
          ...response.data,
          brokenLinks,
          id,
        });
      }
    });
  },

  fetchTemplateSize({ commit }, params) {
    commit("setTemplateContent", params);
  },

  saveRecipients({ commit, state }, params) {
    return campagn.saveRecipients(params).then((response) => {
      commit("setEditItem", {
        ...state.editItem,
        ...params,
        listJson: response.data.listJson,
        campaignListCount: response.data.campaignListCount,
        listSelected: response.data.listSelected,
      });
    });
  },

  publishCampaign({ commit, state }, params) {
    return campagn.publishCampaign(params).then(function (data) {
      params.scheduleTimeVue = params.scheduleTime;
      params.scheduleDateVue = params.scheduleDate;
      params.endTimeVue = params.endTime;
      params.endDateVue = params.endDate;
      params.timeBasedJson = {};
      if (params.timeBasedRules || params.endDate || params.campSpeed) {
        params.timeBasedJson.is_time_based = 1;
      }
      if (params.timeBasedRules) {
        params.timeBasedJson.time_based_rules = { ...params.timeBasedRules };
      }
      commit("setEditItem", { ...state.editItem, ...params, published: true });
      return data.data;
    });
  },

  resetSpamScore({ commit, dispatch }, params) {
    var type = params.campaignType === 3 ? "B" : "";
    commit("setSpamCheckStaus" + type, 0);
    dispatch("fetchSpamScore", params);
  },

  fetchSpamScore({ commit, state }, params) {
    var loginData = JSON.parse(window.localStorage.getItem("login_data"));
    var ids = (process.env.VUE_APP_BLACKLISTDOMAIN_CIDS || "").split(",");
    if (!ids.includes(loginData.cid.toString())) {
      var type = params.campaignType === 3 ? "B" : "";
      if (state["spamCheckedId" + type] !== params.campaignId) {
        commit("setSpamCheckStaus" + type, 0);
        commit("setSpamCheckedId" + type, params.campaignId);
      }
      if (
        !state["spamCheckStaus" + type] &&
        (!state["spamDetails" + type].spamScore ||
          state["spamDetails" + type].blacklistlinks === 2)
      ) {
        commit("setSpamCheckStaus" + type, 1);
        return campagn.fetchSpamScore(params, function (data) {
          commit("setSpamCheckStaus" + type, 2);
          commit("setSpamDetails" + type, {
            ...state["spamDetails" + type],
            ...data,
          });
        });
      }
    }
  },

  setEditItemData({ commit }, data) {
    commit("setEditItem", data);
  },

  resetState({ commit }) {
    commit("resetState");
  },
  updateLink({ state, commit, dispatch }, params) {
    var type = params.type && params.type === 3 ? "B" : "";
    return campagn.updateLink(params).then((response) => {
      var brokenLinks = response.data.brokenLinks
        ? JSON.parse(response.data.brokenLinks)
        : [];
      commit("setEditItem" + type, {
        ...state["editItem" + type],
        ...response.data,
        brokenLinks,
      });
      commit("setSpamDetails" + type, {
        ...state["spamDetails" + type],
        ...response.data,
        brokenLinks,
        spamScore: "",
        blacklistlinks: 2,
      });
      commit("setSpamCheckStaus" + type, 0);
      dispatch("fetchSpamScore", {
        campaignId: params.id,
        campaignType: params.type,
      });
    });
  },
};

// mutations
const mutations = {
  setAdvancedCampaignOptions(state, data) {
    state.advancedCampaignOptions = data;
  },
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },

  setSpamCheckedId(state, id) {
    state.spamCheckedId = id;
  },

  setSpamCheckedIdB(state, id) {
    state.spamCheckedIdB = id;
  },

  setSpamCheckStaus(state, loaded) {
    state.spamCheckStaus = loaded;
  },

  setSpamCheckStausB(state, loaded) {
    state.spamCheckStausB = loaded;
  },

  setItemLoaded(state, loaded) {
    state.itemLoaded = loaded;
  },

  setRecipients(state, { contactList }) {
    state.contactList = contactList;
  },
  setSegments(state, { segmentList }) {
    state.segmentList = segmentList.map((list) => {
      list.count = parseInt(list.count);
      return list;
    });
  },

  setCreateOrEdit(state, createOrEdit) {
    state.createOrEdit = createOrEdit;
  },

  setEditItem(state, editItem) {
    state.editItem = editItem;
  },

  setTemplateContent(state, content) {
    state.templateContent = content;
  },

  setEditItemB(state, editItem) {
    state.editItemB = editItem;
  },

  setSpamDetails(state, spamDetails) {
    state.spamDetails = spamDetails;
  },

  setSpamDetailsB(state, spamDetails) {
    state.spamDetailsB = spamDetails;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setShowFilter(state, status) {
    state.showFilter = status;
  },
  setPublishedStatus(state, status) {
    state.publishedStatus = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
